<template>
  <div class="list-allconversation" v-if="this.messages.length == 0">
      <ul class="overflow-messages" v-if="patients.length > 0">
          <li v-for="patient in patients" :key="patient.id" @click="openConversation(patient.id)">
              {{ patient.firstName }} {{ patient.lastName }}
          </li>
      </ul>

      <div v-else class="conversation">
        <div class="messages">
    			<div class="no-messages">
            <i class="fa fa-comment-alt"></i>
            <h2>Looks like you don't have any messages yet.</h2>
            <span>Message your internist when you have any questions or concerns regarding your prescription.</span>
          </div>
        </div>
      </div>
  </div>
	<div v-else class="conversation">
		<div class="messages">
      <span class="return-list" @click="returnList()"><- return to list</span>
      <div class="message--not--text">
        This is not a live chat, and is for nonemergent questions
      </div>
			<div class="no-messages" v-if="!messages.length">
				<i class="fa fa-comment-alt"></i>
				<h2>Looks like you don't have any messages yet.</h2>
				<span>Message your internist when you have any questions or concerns regarding your prescription.</span>
			</div>
			<div class="error" v-show="hasLoadingBeforeError">
				Could not retrieve additional messages.
			</div>
			<div class="error" v-show="hasSendMessageError">
				Could not send message.
			</div>
			<div class="loading" v-show="isLoadingBefore">
				<div class="dot"></div>
				<div class="dot"></div>
				<div class="dot"></div>
			</div>
			<div v-for="message in messages" :key="message.id" :class="{ 'message': true, 'my-message': messageIsMine(message)}">
				<div class="message--sender">
					<img v-bind:src="getAvatarForMessage(message)" alt="Message from" class="avatar">
				</div>
				<div class="message--content">
					<div class="name">{{ message.sender.firstName }} {{ message.sender.lastName }}</div>
					<div class="body" v-html="message.body">
						{{ message.body }}
					</div>
				</div>
				<div class="message--meta">
					<div class="date">
						{{ localTime(message.dateCreated.date) }}
					</div>
				</div>
			</div>

			<div class="loading" v-show="isLoadingSince">
				<div class="dot"></div>
				<div class="dot"></div>
				<div class="dot"></div>
			</div>
		</div>
		<div class="new-message">
			<textarea v-model="newMessageBody" v-on:keyup="detectEnter" placeholder="Send a message..."></textarea>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
  props: ['myPersonId', 'otherPersonId'],
  data: function() {
    return {
      isLoadingBefore: false,
      isLoadingSince: false,
      hasLoadingBeforeError: false,
      messages: [],
      patients: [],
      newMessageBody: null,
      pollingInterval: 4000,
      isPollingPaused: false,
      hasSendMessageError: false
    };
  },
  mounted() {
    // setInterval(
    //   function() {
    //     this.getAllPacients();
    //   }.bind(this),
    //   this.pollingInterval
    // );

    this.getAllPacients();

    this.$el.querySelector('.messages').addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (this.$el.querySelector('.messages').scrollTop == 0) {
        if (this.messages.length) {
          this.getBefore(this.messages[0]);
        }
      }
    },
    getAllPacients() {
      this.isPollingPaused = true;
      axios
        .get(`/api/v1/messages/allPacients`)
        .then((response) => {
            this.patients = response.data.data;
        })
        .catch(
          function(error) {
            console.log(error)
          }.bind(this)
        );
    },
    returnList(){
      this.messages = [];
    },
    openConversation(patient_id){
      this.isPollingPaused = true;
      axios
        .get(`/api/v1/messages/patient/${patient_id}`)
        .then((response) => {
          if (response.data.data) {
            let results = response.data.data;
            
            let newResults = results.map((result)=> {
              if(result.sender.id == this.myPersonId){
                result.sender.firstName = "Support"
                result.sender.lastName = "";
              }
              return result;
            });
            
            this.messages = newResults;
            this.messages.reverse();
          }
          this.resetScrollPosition();
          this.isPollingPaused = false;
        })
        .catch(
          function(error) {
            this.isPollingPaused = false;
          }.bind(this)
        );
    },
    resetScrollPosition() {

      setTimeout(() => {
        var container = this.$el.querySelector('.messages');
        if(container){
          this.$nextTick(() => {
            container.scrollTop = container.scrollHeight;
          });
        }
      }, 1);
    },
    messageIsMine(message) {
      return message.sender.id == this.myPersonId;
    },
    getAvatarForMessage(message) {
      if (message.sender.avatar) {
        return message.sender.avatar;
      }
      return '/images/default-avatar.png';
    },
    getLatestMessageId() {
      if (this.messages.length) {
        return this.messages[this.messages.length - 1].id;
      }
    },
    sendNewMessage() {
      this.isLoadingSince = true;
      this.hasSendMessageError = false;
      this.resetScrollPosition();

      axios
        .post('/api/v1/messages', { body: this.newMessageBody, re: this.getLatestMessageId()})
        .then((response) => {
          this.isLoadingSince = false;

          let data = response.data.data;
          
          data.sender.firstName = "Support";
          data.sender.lastName = "";

          this.messages.push(data);

          this.resetScrollPosition();
        })
        .catch(
          function(error) {
            this.hasSendMessageError = true;
            this.isLoadingSince = false;
          }.bind(this)
        );
    },
    detectEnter(e) {
      if (e.keyCode === 13) {
        this.newMessageBody = this.newMessageBody.trim();
        if (this.newMessageBody) {
          this.sendNewMessage();
          this.newMessageBody = '';
        }
      }
    },
    localTime(datetime) {
      datetime = datetime.replace(/\.000000/, '');
      let utcDate = moment.utc(datetime);
      return moment(utcDate)
        .local()
        .calendar('', { sameElse: 'M/D/YYYY, h:mm A' });
    },
  },
};
</script>

<style type="sass" scoped>
.list-allconversation{

  .overflow-messages{
    height: 300px;
    overflow-y: scroll;
  }

  ul{
    list-style: none;
  }

  li{
    padding: 10px;
    border-bottom: 1px solid #ccc;
    width: 343px;
    cursor: pointer;
  }

  li:hover{
    background-color: #eaeaea;
  }

  li::before{
    content: '';
  }
}

.return-list{
    padding-bottom: 10px;
    display: block;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/AllConversation.vue